'use strict';

var NetworkError = require('./NetworkError.js');

class UnauthorizedError extends NetworkError.NetworkError {
    constructor(message = 'Unauthorized') {
        super(message, 401);
    }
}

exports.UnauthorizedError = UnauthorizedError;
//# sourceMappingURL=UnauthorizedError.js.map
